import React from 'react';

import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

import Activity from './activity';

import type { MenuOptions } from 'bundles/apex/activities/types';
import type { Parent, ParentOption } from 'bundles/crm/types';
import type { Activity as ActivityType } from 'bundles/apex/activities/types';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ActivityListProps {
  activities: ActivityType[];
  activityMenuOptions?: MenuOptions;
  currentParent?: Parent | Parent[];
  forUserId?: number;
  hasFilters?: boolean;
  hideAfterReparenting?: boolean;
  isBackofficeAdmin?: boolean;
  showParents?: boolean | 'path';
  tagText?: string;
  options?: {
    parents?: ParentOption[];
  }
  onDelete: (activity: ActivityType) => void;
  onSave: (activity: ActivityType) => void;
}

export default function ActivityList({ activities, activityMenuOptions, ...props }: ActivityListProps) {
  if (activities.length === 0) {
    return (
      <Empty className="bg-white">
        <Empty.Media>
          <FontAwesomeIcon icon={faCircleExclamation} />
        </Empty.Media>
        <Empty.Title>No Activities to Display</Empty.Title>
      </Empty>
    );
  }

  return (
    <div className="d-flex flex-column">
      {activities.map(activity => (
        <Activity
          {...props}
          activity={activity}
          key={activity.id}
          menuOptions={activityMenuOptions}
        />
      ))}
    </div>
  );
}
